/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useTranslate } from "../useTranslate";

/**
 * aria props for a toggle whose name flips with pressed state (show/hide
 * password, expand/collapse): `aria-pressed` + a translated `aria-label`.
 *
 *   const showPasswordAria = useToggleAriaProps(showPassword, "Hide password", "Show password");
 *   <button type="button" {...showPasswordAria} />
 *
 * @param {boolean} pressed         current toggle state
 * @param {string}  pressedLabel    label when pressed
 * @param {string}  unpressedLabel  label when not pressed
 */
export const useToggleAriaProps = (pressed, pressedLabel, unpressedLabel) => {
  const { _t } = useTranslate();

  return {
    "aria-pressed": pressed,
    "aria-label": _t(pressed ? pressedLabel : unpressedLabel),
  };
};
